export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'ID sklepu: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Nazwa użytkownika: ',
      placeholder: 'Nazwa użytkownika do uwierzytelnienia między sklepem a WinOrder',
      validation: {
        required: 'Nazwa użytkownika nie może być pusta',
        min: 'Minimalna długość nazwy użytkownika to 3 znaki',
      },
    },
    password: {
      label: 'Hasło: ',
      placeholder: 'Hasło do uwierzytelnienia między sklepem a WinOrder',
      validation: {
        required: 'Hasło nie może być puste',
        complexity: 'Hasło musi mieć co najmniej 8 znaków i zawierać co najmniej jedną literę',
      },
    },
  },
  labels: {
    credentials: 'Dane uwierzytelniające:',
  },
  instructions: {
    title: 'Instrukcje konfiguracji:',
    step_1: 'Otwórz „Ustawienia" → „Ustawienia programu" w WinOrder.',
    step_2: 'Na górze znajdziesz przycisk „Konfiguracja sklepu online".',
    step_3:
      'W kolejnym oknie znajdziesz wszystkie sklepy wstępnie skonfigurowane w WinOrder. Wybierz „FoodAmigos" i kliknij „Dalej".',
    step_4:
      'W kolejnym oknie zastąp <0>{{storeid_placeholder}}</0> przez <1>{{company_id}}</1> w polu „URL usługi sieciowej". <br />Wynik końcowy powinien wyglądać tak: <2>{{url}}</2>',
    step_5: 'W tym samym oknie wprowadź <ClickToCopy>{{username}}</ClickToCopy> w polu „Nazwa użytkownika".',
    step_6:
      'W tym samym oknie wprowadź <ClickToCopy>{{password}}</ClickToCopy> w polu „Hasło". Następnie kliknij przycisk „Dalej".',
    step_7:
      'WinOrder testuje teraz połączenie z interfejsem FoodAmigos. Kliknij „Dalej", a w kolejnym oknie „Zakończ".',
    step_8: 'Zapisz ustawienia.',
  },
  buttons: {
    save: 'Zapisz',
    cancel: 'Anuluj',
    edit: 'Edytuj',
  },
  toasts: {
    error: 'Nie udało się zapisać zmian',
    success: 'Zmiany zostały zapisane',
  },
};
